import { Component, OnInit, OnDestroy  } from '@angular/core';
import { TccDetailService } from '../services/tcc-detail.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { JsonPipe } from '@angular/common';
import { InteractionService } from '../services/interaction.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-tcc-detail',
  templateUrl: './tcc-detail.component.html',
  styleUrls: ['./tcc-detail.component.scss']
})
export class TccDetailComponent implements OnInit,OnDestroy {
 
  validPeriod = [
    {days: 30, desc: "Provisional1"},
    {days: 60, desc: "Provisional2"},
    {days: 90, desc: "Conditional"},
    {days: 180, desc: "Regular"},
    {days: 360, desc: "Annual"}
  ];
  public login:boolean;
  public selectedValue : any = null;
  public selectedPurpose: number = 5;
  public tccdetail :ITccDetail;
  public updateStat : Istatus; 
  private tccNo: string;
  public userEmail:string;
  public userName:string;
  public tccDetails$: Observable<boolean>;
  public hasBeenAssigned : boolean;
  public hasBeenAssessed : boolean;
  public hasBeenRegistered : boolean;
  public isPendingApproval: boolean;
  public isApproved : boolean;
  public canBeQuery : boolean ;
  private _commentIsVisible: boolean;
  private _paymentIsVisible: boolean;
  private _assessmentIsVisible: boolean;  
  private _fillingIsVisible: boolean;
  private _assignOfficerIsVisible: boolean;
  private _documentIsVisible: boolean;   
  private isReviewer : boolean; 
  public purpose:any;

  public daysGrantedByManager: number;
  
 
  private subscription : Subscription = new Subscription();
  constructor(private tccservice : TccDetailService, 
              private route: Router, 
              private actRoute: ActivatedRoute,
              private authservice: AuthService,
              private inters:InteractionService) { 
      this.actRoute.paramMap.subscribe((param: ParamMap)=>{
        this.tccNo = param.get('tccNo');
        localStorage.setItem('tccno', this.tccNo)
        
        //this.user = JSON.parse(localStorage.getItem('user'));
        //this.user = this.authservice.getCurrentUser();
      });
  }

  public get paymentIsVisible(): boolean {
    return this._paymentIsVisible;
  }
  public get assessmentIsVisible(): boolean {
    return this._assessmentIsVisible;
  }

  public get fillingIsVisible(): boolean {
    return this._fillingIsVisible;
  }
  
  public get commentIsVisible(): boolean {
    return this._commentIsVisible;
  }
  public get assignOfficerIsVisible(): boolean {
    return this._assignOfficerIsVisible;
  }
  public get documentIsVisible(): boolean {
    return this._documentIsVisible;
  }

  ngOnInit() {
    this.login = this.authservice.isLoggedIn;
    if(this.login){
     this.subscription.add(
      this.authservice.getCurrentUserTest().subscribe(v=>{
        this.userEmail = v.email;
        this.userName = v.sub;

         

         this.updateStat = {
          tccno: this.tccNo,
          status: 'REGISTERED',
          username: this.userName,
          period: this.selectedValue,
          purpose: this.selectedPurpose
         };

         this.inters.message$.subscribe(pId=>{
          this.selectedPurpose = pId;
          //this.updateStat.purpose = this.selectedPurpose;
        }); 

         
        //console.log(this.user)
        //console.log(this.login);
      },
      err=>{console.log(err)})
     );

     
    
    }
    this.isReviewer = this.authservice.getCurrentUser().usergroup==="Reviewer";
    this.tccDetails$ = this.tccservice.getTccDetailsByTccno(this.tccNo).pipe(tap(r => {
      this.tccdetail = this.tccservice.tccdetail;
      this.hasBeenRegistered = (this.tccdetail.REQUEST_STATUS==="REGISTERED");
      this.hasBeenAssigned = (this.tccdetail.REQUEST_STATUS==="ASSIGNED");
      this.hasBeenAssessed = (this.tccdetail.REQUEST_STATUS==="ASSESSED");
      this.isPendingApproval = (this.tccdetail.REQUEST_STATUS==="PENDING APPROVAL");
      this.isApproved = (this.tccdetail.REQUEST_STATUS==="APPROVED"); 
      //console.log(this.tccdetail);

      if(this.isReviewer){
        this.hasBeenAssigned = false;
        this.hasBeenRegistered = false;
        this.hasBeenAssessed = false;
      }

      if(this.isPendingApproval){
        this.validPeriod.forEach(element => {
          if(element.desc==this.tccdetail.TAX_CLEARANCE_TYPE){
            this.daysGrantedByManager=element.days;
          }
        });
      }
    }))   
    this._commentIsVisible = true;
    //this.tccservice.getPurpose().subscribe(data=>this.purpose=data)
    //console.log(this.isReviewer)

    
  }

  public showSection(sectionNumber: number) {
    localStorage.setItem("tpn", this.tccdetail.TAX_PAYER_NO.toString());
    localStorage.setItem("tin", this.tccdetail.TIN)
    localStorage.setItem("divno", this.tccdetail.TAX_DIVISION_NO.toString());
    sectionNumber = +sectionNumber;
    if (sectionNumber ===1) {   
      this._assessmentIsVisible = false;
      this._fillingIsVisible = false;
      this._paymentIsVisible = false;
      this._assignOfficerIsVisible= false;
      this._documentIsVisible = false;
      this._commentIsVisible= true;
    } else if (sectionNumber === 2) {
      this._commentIsVisible =false;        
      this._paymentIsVisible = false;
      this._assignOfficerIsVisible= false;
      this._fillingIsVisible = false;
      this._documentIsVisible = false;
      this._assessmentIsVisible = true;
    } else if (sectionNumber === 3) {
      this._commentIsVisible =false;        
      this._paymentIsVisible = false;
      this._assessmentIsVisible = false;
      this._assignOfficerIsVisible= false;
      this._documentIsVisible = false;
      this._fillingIsVisible = true;
    } else if (sectionNumber === 4) {
      this._commentIsVisible =false;        
      this._assessmentIsVisible = false;
      this._fillingIsVisible = false;
      this._assignOfficerIsVisible= false;
      this._documentIsVisible = false;
      this._paymentIsVisible = true;
    }
     else if (sectionNumber === 5) {
      this._commentIsVisible =false;        
      this._assessmentIsVisible = false;
      this._fillingIsVisible = false;
      this._paymentIsVisible = false;
      this._documentIsVisible = false;
      this._assignOfficerIsVisible= true;
    }
    else if (sectionNumber === 6) {
      this._commentIsVisible =false;        
      this._assessmentIsVisible = false;
      this._fillingIsVisible = false;
      this._paymentIsVisible = false;
      this._assignOfficerIsVisible= false;
      this._documentIsVisible = true;
    }
    else if (sectionNumber === 7) {
      this._commentIsVisible =false;        
      this._assessmentIsVisible = false;
      this._fillingIsVisible = false;
      this._paymentIsVisible = false;
      this._assignOfficerIsVisible= false;
      this._documentIsVisible = false;
    }
  }

 updateStatus(stat:string){
    if(stat=="APPROVED" || stat=="PENDING APPROVAL"){
      this.updateStat.purpose = this.selectedPurpose;
     
    }
    this.updateStat.status=stat;
    this.updateStat.period=this.selectedValue;
     console.log(this.updateStat);
    this.subscription.add(
      this.tccservice.updateTccStatus(this.updateStat).subscribe(data=>{
       let update = data;
       this.route.navigate(['/admin']);
      })
    );
 }
 
 goBack(){
  this.route.navigate(['/admin']);
 }
 resetPassword(){
  this.route.navigate(['/resetpassword']);
 }

 changePeriod(){
   if(this.selectedValue=="Provisional1"){
    this.daysGrantedByManager=30;
   }
   else if(this.selectedValue=="Provisional2"){
     this.daysGrantedByManager=60;
   }
   else if(this.selectedValue=="Conditional"){
      this.daysGrantedByManager=90;
   }
   else if(this.selectedValue=="Regular"){
     this.daysGrantedByManager=180
   }
   else if(this.selectedValue=="Annual"){
     this.daysGrantedByManager=360
   }
   else{
     this.daysGrantedByManager=0;
   }
 }

 public logout(){
  this.userName = "";
  this.authservice.loggedOut();
  //this.route.navigate(['/login']);
}

 ngOnDestroy(): void {
  this.subscription.unsubscribe;
} 

}
